exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--white:#fff;--black:#000;--grey0:#f7f3f0;--grey1:#a69fa6;--grey2:#aaa;--grey3:#888;--grey4:#2f3954;--blue:#5b7bba;--blue-light:#8ab0e2;--blue-lightest:#cde3ff;--red:#af351c;--red-lightest:#fcd8d1;--green:#2e5139;--green-bright:#2d9e51;--green-lightest:#ceffde;--font-family-base:\"Roboto\",sans-serif;--max-content-width:600px;--text-padding:10px;--row-height:40px;--screen-mobile:600px;--screen-xs-min:480px;--screen-sm-min:768px;--screen-md-min:992px;--screen-lg-min:1200px;--show-height:height;--show-time:0.3s;--show-type:linear}._3pLE2{padding:0}", ""]);

// exports
exports.locals = {
	"dialog_content": "_3pLE2"
};